<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据库</el-breadcrumb-item>
      <el-breadcrumb-item>操作记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="5">
          <el-input placeholder="请输入管理员" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="filterSelect"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker v-model="queryInfo.time" @change="timechange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </el-col>
        <el-col :span="8" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time)">
            <el-button size="mini" type="info">导出操作日志</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <!-- 展开列 -->
        <el-table-column type="index"></el-table-column>
        <el-table-column type="selection" width="55" fixed> </el-table-column>
        <el-table-column label="管理员" prop="username" width="120px"></el-table-column>
        <el-table-column label="操作时间" prop="create_at" width="120px"> </el-table-column>
        <el-table-column label="操作内容" prop="content" align="center"> </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      exportUrl: 'https://hsznttghpt.hsxsn.cn/exportDealHistoryExcel?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        agencyName: '',
        pagenum: 1,
        pagesize: 10,
        time: null
      },
      total: 0,
      orderlist: [],
      multipleSelection: [],
      multipleSelectionjson: null,
      tabIndex: 0
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {
    timechange (e) {
      this.filterSelect();
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      console.log(list)
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/exportDealHistoryExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/exportDealHistoryExcel?mPhone=' + localStorage.getItem('phone')
      }
    },

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/users/getOperationLogList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无订单信息！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}

.daochuA {
  width: 60px;
  height: 24px;
  line-height: 24px;
  align-items: center;
  background-color: blue;
  color: #fff;
  align-content: center;
  margin-left: 20px;
  display: inline-block;
  padding: 20rpx;
  font-size: 14px;
  text-decoration: none;
}
</style>
